"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// The location field works with location items from both the autocomplete
// API, and the history API which return slightly different shapes. This fn
// returns a standard representation of a location item for the `Location`
// component to render.
var getItemNormalizer = exports.getItemNormalizer = function getItemNormalizer(itemType) {
  return function (item) {
    return {
      lat: item.lat,
      lon: item.lon,
      location_id: item.location_id,
      place_id: item.place_id || item.google_place_id,
      main_text: item.main_text || item.name,
      secondary_text: item.secondary_text || item.formatted_address,
      type: itemType,
      timezone: item.timezone
    };
  };
};